import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import useApiData from '../../hooks/useApiData';
import api from '../Tienda/api/api';
import InputSearch from '../InputSearch/InputSearch';
import './Hero.scss';

const PLACEHOLDERS = ['titulo', 'subtitulo', 'texto', 'boton', 'descripcion', 'subtítulo', 'botón', 'descripción'];

const cleanField = (v) => {
	if (!v) return '';
	const t = String(v).trim();
	if (PLACEHOLDERS.includes(t.toLowerCase())) return '';
	return t;
};

const pickFirstSlide = (response) => {
	if (!response) return null;
	if (Array.isArray(response)) return response[0] || null;
	if (Array.isArray(response.data)) return response.data[0] || null;
	if (Array.isArray(response.results)) return response.results[0] || null;
	if (Array.isArray(response.Items)) return response.Items[0] || null;
	if (response.data && typeof response.data === 'object') return response.data;
	return response;
};

const DEFAULT_TITLE = 'Todo para tu obra y tu hogar, en un solo lugar';
const DEFAULT_SUBTITLE = 'Materiales, baño, grifería, herramientas y más. Envíos rápidos en la zona.';

const WHATSAPP_URL = 'https://wa.me/5492914045000?text=' + encodeURIComponent('Hola, quiero hacer una consulta');

const Hero = () => {
	const params = useMemo(() => ({ filters: ['quantity=1'] }), []);
	const { data: heroData } = useApiData(
		api.api.sitio.carrusel,
		null,
		1,
		params,
		pickFirstSlide
	);

	const title = cleanField(heroData?.Titulo || heroData?.titulo || heroData?.title) || DEFAULT_TITLE;
	const subtitle = cleanField(heroData?.Subtitulo || heroData?.subtitulo || heroData?.subtitle) || DEFAULT_SUBTITLE;

	return (
		<section className="hero-redesign">
			<div className="container">
				<div className="row align-items-center">
					<div className="col-12 col-lg-7 hero-redesign__copy">
						<h1 className="hero-redesign__title">{title}</h1>
						<p className="hero-redesign__subtitle">{subtitle}</p>
						<div className="hero-redesign__search">
							<InputSearch />
						</div>
						<div className="hero-redesign__ctas">
							<Link to="/tienda/productos" className="btn btn-primary btn-lg hero-redesign__cta-primary">
								<i className="fa fa-shopping-bag mr-2" aria-hidden="true"></i>
								Ver productos
							</Link>
							<a
								href={WHATSAPP_URL}
								target="_blank"
								rel="noopener noreferrer"
								className="btn btn-success btn-lg hero-redesign__cta-secondary"
							>
								<i className="fa fa-whatsapp mr-2" aria-hidden="true"></i>
								Escribinos por WhatsApp
							</a>
						</div>
					</div>
					<div className="col-12 col-lg-5 d-none d-lg-block hero-redesign__panel">
						<div className="hero-redesign__panel-card">
							<span className="hero-redesign__panel-tag">Miles de productos</span>
							<h3 className="hero-redesign__panel-title">Las mejores marcas para tu proyecto</h3>
							<ul className="hero-redesign__panel-list">
								<li><i className="fa fa-wrench" aria-hidden="true"></i> Construcción y ferretería</li>
								<li><i className="fa fa-paint-brush" aria-hidden="true"></i> Pinturería y revestimientos</li>
								<li><i className="fa fa-bath" aria-hidden="true"></i> Baño y grifería</li>
								<li><i className="fa fa-bolt" aria-hidden="true"></i> Electricidad y herramientas</li>
							</ul>
							<Link to="/tienda/productos" className="hero-redesign__panel-link">
								Explorar catálogo <i className="fa fa-arrow-right" aria-hidden="true"></i>
							</Link>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Hero;
